export const SHOW_PULSE_CHECK_MODAL = 'showPulseCheckModal';
